<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <div v-else style="height: 100%">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column is-3">
                    <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-mao-obra" />
                </div>
                <div class="column is-2">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-2">
                    <vss-select
                        :searchable="false"
                        :options="tipoAlocacaoSelect"
                        v-model="tipoAlocacaoSelected"
                        mlLabels
                        title="tipo-alocacao"
                        clearable
                        @input="onTipoAlocacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-2">
                    <vss-select
                        :searchable="false"
                        :options="tipoCobrancaSelect"
                        v-model="tipoCobrancaSelected"
                        mlLabels
                        title="tipo-cobranca"
                        clearable
                        @input="onTipoCobrancaChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularMaoObra"
                    >
                        {{ $t('vincular-mao-de-obra-alocada') }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprodutoMaoObra"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label ? f.label : f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'descricaocargo'">
                            <a @click="selectedMaoObraEdit(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div>
                    <MaoDeObraAlocadaModal
                        :idcliente="$route.params.id"
                        :selected="assMaoObraSelected"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssClienteMaoDeObraService from '@/services/promotor/cliente/AssClienteMaoDeObraService';
import MaoDeObraAlocadaModal from '@/components/promotor/cliente/modal/MaoObraAlocadaModal';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        MaoDeObraAlocadaModal,
    },
    data() {
        return {
            accessDenied: false,
            assprodutoMaoObra: [],
            fields: [
                {
                    key: 'descricaocargo',
                    label: 'cargo',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'tipoCobranca', label: 'tipo-cobranca', sortable: true, sortFn: null },
                { key: 'tipoAlocacao', label: 'tipo-alocacao', sortable: true, sortFn: null },
                {
                    key: 'qtde',
                    label: 'quantidade-colaboradores-contratados',
                    sortable: true,
                    sortFn: null,
                },
                { key: 'valorunitariocusto', label: 'valor-unitario-custo', sortable: true, sortFn: null },
                { key: 'valorunitariofinal', label: 'valor-unitario-final', sortable: true, sortFn: null },

                { key: 'situacao', sortable: true, sortFn: null },
                { key: 'excluir', sortable: false, sortFn: null },
            ],
            service: new AssClienteMaoDeObraService(this.$http, this.$router),
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            assMaoObraSelected: null,
            isEmpty: false,
            debouncedOnSearch: null,
            searchQuery: '',
            column: 'descricaocargo',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            //FILTROS
            tipoAlocacaoSelected: { id: 0, key: 'T', label: 'todos' },
            tipoAlocacaoSelect: [
                { id: 0, key: 'T', label: 'todos' },
                { id: 1, key: 'M', label: 'mensal' },
                { id: 2, key: 'A', label: 'avulso' },
            ],
            tipoCobrancaSelected: { id: 0, key: 'T', label: 'todos' },
            tipoCobrancaSelect: [
                { id: 0, key: 'T', label: 'todos' },
                { id: 1, key: 'M', label: 'mensal' },
                { id: 2, key: 'D', label: 'diaria' },
                { id: 3, key: 'H', label: 'por-hora' },
            ],
            situacaoSelected: { id: 2, label: 'todos' },
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'clientes');
        if (!this.permissao.read) {
            this.accessDenied = true;
            return;
        }
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findAllByIdCliente(
                    this.$route.params.id,
                    this.column,
                    this.situacaoSelected.id,
                    this.tipoCobrancaSelected.key,
                    this.tipoAlocacaoSelected.key,
                    this.pagination.perPage,
                    currentPage - 1,
                    this.order,
                    this.searchQuery
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assprodutoMaoObra = value;
                    this.isEmpty = this.assprodutoMaoObra.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idcargo: m.cargo.idcargo,
                    descricaocargo: m.cargo.descricao,
                    idassclientemaodeobra: m.idassclientemaodeobra,
                    qtde: m.qtde,
                    tipoAlocacao:
                        m.tipoAlocacao == 'M' ? 'Mensal' : m.tipoAlocacao == 'A' ? 'Avulso' : null,
                    tipoCobranca:
                        m.tipoCobranca == 'M'
                            ? 'Mensal'
                            : m.tipoCobranca == 'D'
                            ? 'Diária'
                            : m.tipoCobranca == 'H'
                            ? 'Por hora'
                            : null,
                    valorunitariocusto: m.valorunitariocusto,
                    valorunitariofinal: m.valorunitariofinal,
                    situacao: m.situacao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onTipoAlocacaoChanged(val) {
            this.tipoAlocacaoSelected = val
                ? this.tipoAlocacaoSelect.filter((v) => v.id == val.id)[0]
                : this.tipoAlocacaoSelect[0];
            this.carregarDados();
        },
        onTipoCobrancaChanged(val) {
            this.tipoCobrancaSelected = val
                ? this.tipoCobrancaSelect.filter((v) => v.id == val.id)[0]
                : this.tipoCobrancaSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricaocargo'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.situacao == 1 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('mao-de-obra-alocada') }
                );
            let tempAssClienteMaoObra = {
                idassclientemaodeobra: this.delete.idassclientemaodeobra,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;
            this.service
                .updateSituacao(tempAssClienteMaoObra)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('mao-de-obra-alocada') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        selectedMaoObraEdit(selected) {
            this.assMaoObraSelected = selected;
            this.showModalAssociacao = true;
        },
        showModalVincularMaoObra() {
            this.assMaoObraSelected = null;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.assMaoObraSelected = null;
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .botao-acao {
        margin-top: 0;
    }
}
</style>
